import { inView, timeline } from "motion";

const timelineItems = document.querySelectorAll(".timeline-item");

timelineItems.forEach((item) => {
  inView(
    item,
    () => {
      timeline([
        [
          item.querySelector(".timeline-date"),
          {
            opacity: 1,
            transform: "translate3d(0, 0, 0)",
          },
          { duration: 0.5 },
        ],
        [
          item.querySelector(".timeline-content"),
          {
            opacity: 1,
            transform: "translate3d(0, 0, 0)",
          },
          { duration: 0.5 },
        ],
        [
          item.querySelector(".timeline-centered"),
          {
            opacity: 1,
            transform: "translate3d(0, 0, 0)",
          },
          { duration: 0.5 },
        ],
      ]);
    },
    {
      margin: "0px 0px -25% 0px",
    },
  );
});
